import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import classNames from "classnames";
import AwesomeIcon from "../AwesomeIcon";
var SearchableCombobox = function SearchableCombobox(_ref) {
  var _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Select" : _ref$placeholder,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$parentClassName = _ref.parentClassName,
    parentClassName = _ref$parentClassName === void 0 ? "" : _ref$parentClassName,
    _ref$isBottomAligned = _ref.isBottomAligned,
    isBottomAligned = _ref$isBottomAligned === void 0 ? false : _ref$isBottomAligned,
    _ref$debounceMs = _ref.debounceMs,
    debounceMs = _ref$debounceMs === void 0 ? 300 : _ref$debounceMs;
  var _useState = useState(""),
    query = _useState[0],
    setQuery = _useState[1];
  var _useState2 = useState(""),
    debouncedQuery = _useState2[0],
    setDebouncedQuery = _useState2[1];
  var inputRef = useRef(null);
  useEffect(function () {
    var timer = setTimeout(function () {
      return setDebouncedQuery(query);
    }, debounceMs);
    return function () {
      return clearTimeout(timer);
    };
  }, [query, debounceMs]);
  var filteredOptions = useMemo(function () {
    if (!debouncedQuery) return options;
    var lower = debouncedQuery.toLowerCase();
    return options.filter(function (opt) {
      var _opt$label;
      return (_opt$label = opt.label) === null || _opt$label === void 0 ? void 0 : _opt$label.toLowerCase().includes(lower);
    });
  }, [debouncedQuery, options]);
  var onAfterLeave = function onAfterLeave() {
    setQuery("");
    setDebouncedQuery("");
  };
  return /*#__PURE__*/React.createElement(Combobox, {
    value: value,
    onChange: onChange,
    as: "div",
    className: classNames("relative w-full", _defineProperty({}, parentClassName, !!parentClassName))
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(" rounded-md pr-4 py-[3px]", _defineProperty({}, className, !!className)),
    onClick: function onClick() {
      var _inputRef$current;
      return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, /*#__PURE__*/React.createElement(Combobox.Button, {
    className: "shrink-0 ml-2 flex items-center justify-between w-full"
  }, /*#__PURE__*/React.createElement(Combobox.Input, {
    ref: inputRef,
    displayValue: function displayValue(opt) {
      return opt !== null && opt !== void 0 && opt.value ? (opt === null || opt === void 0 ? void 0 : opt.label) || "" : "";
    },
    onChange: function onChange(e) {
      return setQuery(e.target.value);
    },
    placeholder: placeholder,
    className: "flex-1 min-w-0 bg-transparent border-none outline-none text-black dark:text-gray-400 placeholder:italic placeholder:text-gray-400 placeholder:dark:text-gray-600 text-[14px] py-0",
    onFocus: function onFocus(e) {
      return e.target.select();
    },
    autoComplete: "off"
  }), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronUp,
    className: "w-4 h-4 text-black dark:text-gray-200 opacity-50 rotate-180 ui-open:!rotate-0"
  }))), /*#__PURE__*/React.createElement(Transition, {
    enter: "transition duration-100 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-75 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0",
    afterLeave: onAfterLeave
  }, /*#__PURE__*/React.createElement(Combobox.Options, {
    className: classNames("absolute z-50 w-full flex flex-col max-h-[170px] overflow-y-auto overflow-x-hidden scrollbar-light dark:scrollbar", "bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 border border-gray-500 rounded-md text-left", {
      "top-[30px]": isBottomAligned,
      "top-full mt-1": !isBottomAligned
    })
  }, filteredOptions.map(function (opt, index) {
    var _opt$value;
    return /*#__PURE__*/React.createElement(Combobox.Option, {
      key: (_opt$value = opt.value) !== null && _opt$value !== void 0 ? _opt$value : index,
      value: opt,
      as: Fragment
    }, function (_ref2) {
      var active = _ref2.active,
        selected = _ref2.selected;
      return /*#__PURE__*/React.createElement("div", {
        title: opt.label,
        className: classNames("w-full min-w-0 px-4 py-4 cursor-pointer", {
          "border-b border-b-gray-500": filteredOptions.length - 1 !== index,
          "bg-teal-500 text-gray-100 dark:bg-teal-800": active || selected
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "block w-full min-w-0 truncate leading-normal"
      }, opt.label));
    });
  }))));
};
export default SearchableCombobox;